// REGISTER
import type { IStepperStep } from "@front-shared/types/objects.types.ts"

import { EmailStep } from "../components/auth/register/steps/email.step"
import { PasswordStep } from "../components/auth/register/steps/password.step"

export const STEPPER_CONFIG = {
    get registerSteps(): IStepperStep[] {
        return [
            {
                key: "emailData",
                stepComponent: EmailStep,
            },
            {
                key: "passwordData",
                stepComponent: PasswordStep,
            },
        ]
    },
}
